import { createSlice } from "@reduxjs/toolkit";
import ServerRoutes from "../api/routes";
import { get, post } from "../api/http";

const initialState = {
  guests: {},
  guest: {},
  guestsError: null,
  guestsLoading: false,
};

const _addGuest = (state, action) => {
  let editedGuests = { ...state.guests };
  editedGuests[action.payload.id] = {
    ...action.payload.body,
    done: false,
    _id: action.payload.id,
    dateAdded: action.payload.dateAdded,
  };
  state.guests = editedGuests;
};

const _setGuests = (state, action) => {
  state.guests = action.payload;
  state.guestsLoading = false;
};

const _setGuest = (state, action) => {
  state.guest = action.payload;
};

const _editGuest = (state, action) => {
  let editedGuests = { ...state.guests };
  for (const [key, value] of Object.entries(action.payload.body))
    editedGuests[action.payload._id][key] = value;
  state.guests = editedGuests;
};

const _editGuests = (state, action) => {
  let editedGuests = { ...state.guests };
  const { ids, body } = action.payload;
  for (let i = 0; i < ids.length; i++)
    for (const [key, value] of Object.entries(body))
      editedGuests[ids[i]][key] = value;
  state.guests = editedGuests;
};

const _deleteGuest = (state, action) => {
  let editedGuests = { ...state.guests };
  for (let i = 0; i < action.payload.length; i++)
    delete editedGuests[action.payload[i]];
  state.guests = editedGuests;
};

const _actionStart = (state) => {
  state.guestsLoading = true;
  state.guestsError = null;
};

const _actionSuccess = (state) => {
  state.guestsLoading = false;
  state.guestsError = null;
};

const _actionFailed = (state, action) => {
  state.guestsLoading = false;
  state.guestsError = action.payload.error;
};

const guests = createSlice({
  name: "guests",
  initialState,
  reducers: {
    addGuest: _addGuest,
    setGuest: _setGuest,
    setGuests: _setGuests,
    editGuest: _editGuest,
    editGuests: _editGuests,
    deleteGuest: _deleteGuest,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = guests;

const {
  setGuest,
  setGuests,
  // addGuest,
  editGuest,
  deleteGuest,
  actionStart,
  actionFailed,
  actionSuccess,
  editGuests,
} = actions;

export default reducer;

export const getAll = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(ServerRoutes.Guests.getAll, {});
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setGuests(data));
  };
};

export const getAllGAvivit = (uid) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Guests.getAllAvivit,
      { uid }
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const getById = (id) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Guests.getById, {
      id,
    });
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(setGuest(data));
    }
  };
};

export const cleanAll = () => {
  return async (dispatch) => {
    dispatch(setGuests({}));
  };
};

// export const add = (body) => {
//   return async (dispatch) => {
//     dispatch(actionStart());
//     const { data, error, status } = await post(ServerRoutes.Guests.add, body);
//     if (status !== 200) return dispatch(actionFailed({ error }));
//     else {
//       dispatch(actionSuccess());
//       return dispatch(
//         addGuest({ id: data.id, dateAdded: data.dateAdded, body })
//       );
//     }
//   };
// };

export const editArrival = (_id, body) => {
  // console.log("body ", body);
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Guests.editArrival + _id,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      return dispatch(actionSuccess());
    }
  };
};

export const editArrived = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Guests.editArrive + _id,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editGuest({
          _id,
          body,
        })
      );
    }
  };
};

export const editGift = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Guests.editGift + _id,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editGuest({
          _id,
          body,
        })
      );
    }
  };
};

export const getGuestAdmin = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Guests.getGuestAdmin,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(setGuests(data));
    }
  };
};

export const findByPhones = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(
      ServerRoutes.Guests.findByPhones + _id,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      return dispatch(actionSuccess());
    }
  };
};

export const edit = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Guests.edit + _id, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editGuest({
          _id,
          body,
        })
      );
    }
  };
};

export const seperation = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Guests.seperation, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      return dispatch(actionSuccess());
    }
  };
};

export const editMany = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Guests.editMany, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());

      const { ids } = body;
      let tempBody = { ...body };
      delete tempBody["ids"];
      return dispatch(
        editGuests({
          ids,
          body: tempBody,
        })
      );
    }
  };
};

export const deleteF = (ids) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Guests.delete, { ids });
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(deleteGuest(ids));
    }
  };
};

export const addMany = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Guests.addMany, body);
    if (status !== 200) return dispatch(actionFailed({ error, kind: "csv" }));
    else {
      return dispatch(actionSuccess());
    }
  };
};

export const addG2T = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Guests.AddG2T, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};
